var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div data-role=\"toolbar\" class=\"col-xs-12 col-sm-6 col-md-6\">\n    <button data-action=\"toolbar\" class=\"btn btn-default\" type=\"button\">toolbar</button>\n\n    <button data-role=\"filter-btn\" class=\"btn btn-default\" type=\"button\">\n        <span class=\"glyphicon glyphicon-filter\" aria-hidden=\"true\"></span>\n    </button>\n</div>\n\n<div>\n    <button data-action=\"toolbar\" class=\"btn btn-default\" type=\"button\">toolbar</button>\n\n    <div class=\"alert alert-warning\" role=\"alert\"><h1>Hi i'm the blank tab: "
    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
    + "</h1></div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/tabs/blank.hbs
// module id = 61
// module chunks = 0